import React, { InputHTMLAttributes } from 'react';
import './Input.scss';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
	disabled?: boolean;
	value?: any;
	onChange?: any;
	onFocus?: any;
	onBlur?: any;
	type?: string;
	onClick?: any;
}

const Input = React.forwardRef((props: Props, ref: any) => (
	<input
		{...props}
		ref={ref}
		className={`Input ${props.className || ''}`}
		disabled={props.disabled}
	/>
));

export default Input;